module.exports = __webpack_public_path__ + "img/fast-transactions1x.67d01413.png";